import React, {Component} from "react";
import styles from "./LastPosts.module.scss";

export default class LastPosts extends React.Component {
    getPostList() {
        const postList = [];
        this.props.postEdges.forEach(postEdge => {
          postList.push({
            path: postEdge.node.fields.slug,
            title: postEdge.node.frontmatter.title,
          });
        });
        return postList;
      }    
    render() {
        let Post = {'title': 'Post 1',
                        'url' : '#'
                       };
        let Post2 = {'title': 'Post 2',
        'url' : '#'
        };
        let Post3 = {'title': 'Post 3',
        'url' : '#'
        };
        console.log(this.props);
        const postEdges = this.props.data.allMarkdownRemark.edges;
        const postList = this.getPostList();

        let postHmtlList = (
            <ul>
                {postList.map((post) =>
                    <li key={post.title.toString()}>
                        <a href={post.url} title={post.title} >{post.title}</a>
                    </li>
                )}
            </ul>
        );

        return (
            <div className="col-lg-3 col-md-6 col-12 animate-box">
                <div className={`dozjedijzidz ${styles.footerwidget}`}>
                    <h3>Derniers articles</h3>
                    <p>
                    {postHmtlList}
                    </p>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/LastPosts/LastPosts.jsx